import { render, staticRenderFns } from "./TheDesktopNavigation.vue?vue&type=template&id=219f5536"
import script from "./TheDesktopNavigation.vue?vue&type=script&lang=js"
export * from "./TheDesktopNavigation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports